import { render, staticRenderFns } from "./CreateNotificationDialog.vue?vue&type=template&id=c0b4b6f0&"
import script from "./CreateNotificationDialog.vue?vue&type=script&lang=js&"
export * from "./CreateNotificationDialog.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports